import React, { PureComponent } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { FormUtils as GetAllFormFields, TableComp } from 'sz-react-utils'
import { Button, Card, Form, notification, Tabs, Tooltip, Popconfirm } from 'antd'
import _ from 'lodash'
import { hideLoader, showLoader } from '../../modules/actions';
import Request from '../../request'
import { connect } from 'react-redux'
import styles from '../Desk/registration/all/styles.less'
import Settings from '../../components/_utils/settings';
import { RightsWrapper } from '../../components/_utils/utils'

import moment from 'moment'

const TabPane = Tabs.TabPane

@Form.create()
class Telecaller extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            totalTelecaller: 0,
            isActive: true,
            refreshChild: false,
            assignDataFor: false,
            telecallerArr: [],
            counsellorArr: [],
            ratingArr: [],
            ratingsObject: [],
            allCountries: [],
        }
        this.table = React.createRef()
        this.loadTelecallers()
    }

    async componentDidMount() {

        let { data: allCounsellors } = await Request.loadUser({
            results: 10000,
            isCounsellor: true,
            active: true
        })

        this.setState({ counsellorArr: allCounsellors })

        let { data: allTelecallers } = await Request.loadUser({
            results: 10000,
            isTelecaller: true,
            active: true
        })

        this.setState({ telecallerArr: allTelecallers });
        this.getAllRatings();
        this.getAllCountries();
    }

    callback = key => {
    }

    loadTelecallers = (params) => {
        return new Promise(async resolve => {
            if (!params) {
                params = {}
            }
            if (!params.sortField) {
                params.sortField = '_id'
                params.sortOrder = 'descend'
            }

            let data = await Request.loadTelecaller({ ...params, regExFilters: ['telecallerId.name'] })
            this.setState({ totalTelecaller: data.total })
            resolve(data)
        })
    }

    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                dispatch(showLoader())
                let x = await Request.addTelecaller(values)
                dispatch(hideLoader())

                if (!x.error) {
                    notification.success({
                        message: 'Telecaller Added successfully'
                    })
                    form.resetFields()
                    if (this.table && this.table.current) this.reload()
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        })
    }

    reload = () => {
        this.table.current.reload()
    }

    refreshFxn = () => {
        this.setState({ refreshChild: !this.state.refreshChild })
    }

    renderStatus = (val) => {
        if (!Array.isArray(val)) {
            val = [val];
        }
        let statusHtml = [];
        if (val.includes("Super Hot")) {
            statusHtml.push(<div className={styles.SuperHot}>Super Hot</div>);
        }
        if (val.includes("Fit2Apply")) {
            statusHtml.push(<div className={styles.Fit2Apply}>Fit2Apply</div>);
        }
        if (val.includes("Neutral")) {
            statusHtml.push(<div className={styles.LukeWarm}>Neutral</div>);
        }
        if (val.includes("Potential")) {
            statusHtml.push(<div className={styles.Potential}>Potential</div>);
        }
        if (val.includes("Dead")) {
            statusHtml.push(<div className={styles.dead}>Dead</div>);
        }
        if (val.includes("Cold")) {
            statusHtml.push(<div className={styles.Cold}>Cold</div>);
        }
        if (val.includes("Active")) {
            statusHtml.push(<div className={styles.Cold}>Active</div>);
        }
        return statusHtml;
    };

    deleteTemplate = async data => {
        this.setState({ loading: true })
        await Request.deleteTelecaller(data)
        this.setState({ loading: false })
        this.reload()

        notification.success({
            message: 'Deleted Successfully',
            duration: 20,
            key: `${data._id}-close`
        })
    }

    getAllRatings = async () => {
        let response = await Request.getRatingsDetails({
            results: 1000,
            count: 1000
        })
        let ratingsObject = [];
        response.data && response.data.map((rating) => {
            ratingsObject[rating._id] = rating;
        })
        console.log(ratingsObject);
        this.setState({ ratingArr: response.data, ratingsObject: ratingsObject })
    }

    getAllCountries = () => {
        let params = {
            results: 100,
            sortField: 'countryName',
            sortOrder: 'ascend'
        }
        Request.getCountries(params).then((resp) => {
            if (resp) {
                let countries = [{ display: '---Select All---', id: 'all' }];
                _.each(resp.data, (vv) => {
                    countries.push({
                        name: vv.countryName,
                        display: vv.countryName,
                        id: vv._id,
                    })
                });
                this.setState({ allCountries: countries })
            }
        }).catch((err) => {
            this.error(err)
        })
    }
    render() {
        const {
            form: { getFieldDecorator, setFieldsValue }
        } = this.props

        const { assignDataFor, telecallerArr, counsellorArr, ratingArr, ratingsObject, allCountries } = this.state

        let inputTypes = {
            fields: [
                {
                    label: 'Telecaller',
                    key: 'telecallerId',
                    required: true,
                    showSearch: true,
                    allowClear: true,
                    placeholder: 'Select Telecaller',
                    keyAccessor: x => x._id,
                    valueAccessor: x => x.name,
                    type: 'select',
                    disabled: false,
                    options: telecallerArr ? telecallerArr : [],
                    onChange: val => {
                        setFieldsValue({
                            telecallerId: val
                        })
                    }
                },
                {
                    label: 'Counsellor',
                    key: 'counsellorId',
                    required: true,
                    showSearch: true,
                    allowClear: true,
                    placeholder: 'Counsellor',
                    keyAccessor: x => x._id,
                    valueAccessor: x => x.name,
                    type: 'select',
                    disabled: false,
                    options: counsellorArr ? counsellorArr : [],
                    onChange: val => {
                        setFieldsValue({
                            counsellorId: val
                        })
                    }
                },
                {
                    label: 'Country',
                    key: 'countryIds',
                    required: true,
                    type: 'select',
                    options: allCountries,
                    mode: 'multiple',
                    onChange: v => {
                        let val = v ? v : [];
                        if (v && v.length && v.includes("all")) {
                            if (v.length === allCountries.length) {
                                val = [];
                            } else {
                                val = allCountries.slice(1).map(levelOption => levelOption.id)

                            }
                        }
                        this.props.form.setFieldsValue({ countryIds: val })
                    }
                },
                {
                    label: 'Assign Data For',
                    key: 'assignDataFor',
                    required: true,
                    type: 'select',
                    options: ['FollowUp', 'CounsellingDesk'],
                    onChange: val => {
                        if (val == 'FollowUp') {
                            this.setState({ assignDataFor: false });
                        } else {
                            this.setState({ assignDataFor: true });
                        }
                        this.props.form.setFieldsValue({
                            assignDataFor: val
                        })
                    }
                },
                {
                    label: 'Desk',
                    key: 'atLevel',
                    required: true,
                    type: 'select',
                    options: Object.values(Settings.deskNameObj),
                    hidden: assignDataFor,
                    onChange: val => {
                        this.props.form.setFieldsValue({
                            atLevel: val
                        })
                    }
                },
                {
                    label: 'Rating',
                    key: 'rating',
                    required: true,
                    type: 'select',
                    mode: 'multiple',
                    keyAccessor: (x) => x._id,
                    valueAccessor: (x) => x.ratingName,
                    options: ratingArr,
                    onChange: val => {
                        this.props.form.setFieldsValue({
                            rating: val
                        })
                    }
                },
                {
                    label: 'Start Date',
                    key: 'startDate',
                    type: 'date',
                },
                {
                    label: 'End Date',
                    key: 'endDate',
                    type: 'date',
                }
            ]
        }

        const userColumn = [
            {
                title: 'Telecaller',
                dataIndex: 'telecallerId.name',
                key: 'telecallerId',
                searchTextName: 'telecallerId.name',
                sorter: true
            },
            {
                title: 'Counsellor',
                dataIndex: 'counsellorId.name',
                key: 'counsellorId',
                searchTextName: 'counsellorId.name',
                sorter: true,
            },
            {
                title: 'Desk',
                dataIndex: 'atLevel',
                key: 'atLevel',
                filters: Settings.deskNameObj !== undefined && Object.values(Settings.deskNameObj).map((x) => ({ value: x, text: x })),
                render: (val, record) => {
                    return (val === 'Front Desk' ? "Counselling Desk" : val)
                }
            },
            {
                title: 'Assign Data For',
                dataIndex: 'assignDataFor',
                key: 'assignDataFor',
                filters: ['FollowUp', 'ConsellingDesk'].map((x) => ({ value: x, text: x }))
            },
            {
                title: "Rating",
                key: "rating",
                dataIndex: "rating",
                filters: ratingArr && ratingArr.map((x) => ({ value: x._id, text: x.ratingName })),
                render: (val, record) => {
                    return (
                        <div>
                            {
                                record.rating && Array.isArray(record.rating) && record.rating.length ?
                                    record.rating.map((rtng, index) => {
                                        let ratingObject = ratingsObject[rtng];
                                        return (<div key={index} className="antd-pro-containers-desk-counselling-all-styles-rating" style={{ background: ratingObject && ratingObject.ratingColor, borderColor: ratingObject && ratingObject.ratingColor }}>{ratingObject && ratingObject.ratingName} &nbsp;</div>)
                                    })
                                    : null
                            }
                        </div>
                    )
                },
            },
            {
                title: "Date Range",
                key: "startDate",
                dataIndex: "startDate",
                render: (text, record) => (
                    <div >
                        <React.Fragment>
                            <div>
                                <div><b>Start Date:-</b> {moment(record.startDate).format('DD/MM/YYYY')}</div>
                                <div><b>End Date:-</b> {moment(record.endDate).format('DD/MM/YYYY')}</div>
                            </div>
                        </React.Fragment>
                    </div>
                ),
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => (
                    <React.Fragment>
                        <RightsWrapper myRight={'TelecallerManagement.delete'}>
                            <Tooltip title="Delete Telecaller">
                                <Popconfirm
                                    title="Are you sure delete this Telecaller?"
                                    onConfirm={() => {
                                        this.deleteTemplate({ _id: record._id })
                                    }}
                                    onCancel={() => {
                                        console.log()
                                    }}
                                    okText="Yes"
                                    cancelText="No">
                                    <Button
                                        className={styles.btn}
                                        shape="circle"
                                        icon="delete"
                                    />
                                </Popconfirm>
                            </Tooltip>
                        </RightsWrapper>
                    </React.Fragment>
                )
            }

        ]

        return (
            <PageHeaderWrapper title={'TELECALLER MANAGEMENT'}>
                <Card bordered={true}>
                    <Tabs onChange={this.callback} type="card">
                        <TabPane tab={'Add Telecaller'} key={0}>
                            <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>

                                <GetAllFormFields
                                    inputSchema={inputTypes}
                                    refresh={this.refreshFxn}
                                    loading={this.props.loading}
                                    getFieldDecorator={getFieldDecorator}
                                />

                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10, marginLeft: '33%' }}
                                    loading={this.props.loading}>
                                    SAVE
                                </Button>
                            </Form>
                        </TabPane>
                        <TabPane tab={`Telecaller `} key={1} >

                            <TableComp
                                columns={userColumn}
                                ref={this.table}
                                apiRequest={params => this.loadTelecallers(params)}
                                pagination={{
                                    showSizeChanger: true,
                                    defaultPageSize: 200,
                                    pageSizeOptions: ['10', '20', '50', '100', '1000']
                                }}
                            />

                        </TabPane>
                    </Tabs>
                </Card>


            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Telecaller)
